interface ConfirmDialogProps {
  bits: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ bits, onConfirm, onCancel }: ConfirmDialogProps) {
  return (
    <div className="confirm-dialog">
      <h3>Confirm Drawing</h3>
      <div className="bits-required">Required Bits: {bits}</div>
      <p style={{ marginBottom: '16px', opacity: 0.8, fontSize: '14px' }}>
        Your drawing will appear for everyone on stream!
      </p>
      <div className="buttons">
        <button className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
        <button className="confirm-btn" onClick={onConfirm}>
          Use Bits
        </button>
      </div>
    </div>
  );
}
